import { MaterialReactTable } from 'material-react-table'

import { Card, CardContent, CardHeader } from '../../../components/ui/card'
import { useOneShopMessageStats } from '../oneshop-message-stats-queries'

import type { MRT_ColumnDef } from 'material-react-table'

import type { OneShopMessageStatsData } from '../oneshop-message-stats.schema'

const columns: Array<MRT_ColumnDef<OneShopMessageStatsData>> = [
  { accessorKey: 'type', header: 'Type' },
  { accessorKey: 'status', header: 'Status' },
  { accessorKey: 'count', header: 'Count' },
  {
    accessorKey: 'dateSentAverageSeconds',
    header: 'Delay Total(s)',
    accessorFn: (row) => row.dateSentAverageSeconds?.toFixed(1),
  },
  {
    accessorKey: 'dateSentMinSeconds',
    header: 'Delay Min(s)',
    accessorFn: (row) => row.dateSentMinSeconds?.toFixed(1),
  },
  {
    accessorKey: 'dateSentMaxSeconds',
    header: 'Delay Max(s)',
    accessorFn: (row) => row.dateSentMaxSeconds?.toFixed(1),
  },

  {
    accessorKey: 'dateQueuedAverageSeconds',
    header: 'Delay Queue(s)',
    accessorFn: (row) => row.dateQueuedAverageSeconds?.toFixed(1),
  },
  {
    accessorKey: 'dateQueuedMinSeconds',
    header: 'Delay Queue Min(s)',
    accessorFn: (row) => row.dateQueuedMinSeconds?.toFixed(1),
  },
  {
    accessorKey: 'dateQueuedMaxSeconds',
    header: 'Delay Queue Max(s)',
    accessorFn: (row) => row.dateQueuedMaxSeconds?.toFixed(1),
  },

  {
    accessorKey: 'queuedSentAverageSeconds',
    header: 'Delay Sent(s)',
    accessorFn: (row) => row.queuedSentAverageSeconds?.toFixed(1),
  },
  {
    accessorKey: 'queuedSentMinSeconds',
    header: 'Delay Sent Min(s)',
    accessorFn: (row) => row.queuedSentMinSeconds?.toFixed(1),
  },
  {
    accessorKey: 'queuedSentMaxSeconds',
    header: 'Delay Sent Max(s)',
    accessorFn: (row) => row.queuedSentMaxSeconds?.toFixed(1),
  },
]

function OneShopMessageStatsMulti() {
  const { data, isLoading, isError } = useOneShopMessageStats()

  if (!data) return null

  if (isError) {
    return (
      <Card>
        <CardContent>Something went wrong loading the broadcasts.</CardContent>
      </Card>
    )
  }

  if (isLoading) {
    return (
      <Card>
        <CardContent>Loading...</CardContent>
      </Card>
    )
  }

  const { email, sms } = data

  const emailInFlight =
    email.pending.count +
    email.queued.count +
    email.accepted.count +
    email.sending.count +
    email.delivered.count
  const emailNotSent =
    email.failed.count + email.undelivered.count + email.canceled.count
  const smsInFlight =
    sms.pending.count +
    sms.queued.count +
    sms.accepted.count +
    sms.sending.count +
    sms.delivered.count
  const smsNotSent =
    sms.failed.count + sms.undelivered.count + sms.canceled.count
  return (
    <>
      <div className="ion-padding-horizontal mx-auto flex max-w-lg gap-x-4">
        <Card>
          <CardHeader>Email</CardHeader>
          <CardContent>
            <p>In flight: {emailInFlight}</p>
            <p>Delivered: {email.sent.count}</p>
            <p>Not Sent: {emailNotSent}</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>SMS</CardHeader>
          <CardContent>
            <p>In flight: {smsInFlight}</p>
            <p>Delivered: {sms.sent.count}</p>
            <p>Not Sent: {smsNotSent}</p>
          </CardContent>
        </Card>
      </div>

      <div className="ion-padding">
        <Card>
          <CardContent>
            <MaterialReactTable
              columns={columns}
              data={data.data}
              enableToolbarInternalActions={false}
              initialState={{ showGlobalFilter: true, density: 'compact' }}
              state={{
                isLoading,
              }}
            />
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export { OneShopMessageStatsMulti }
